// extracted by mini-css-extract-plugin
module.exports = {"searchList":"styles_searchList__3JJaQ","searchItem":"styles_searchItem__2BF0B"};